import { Dropdown } from 'react-bootstrap'
import { DropdownItemProps } from 'react-bootstrap/esm/DropdownItem'
import WithoutPermissionsReports from 'components/tooltips/WithoutPermissionsReports'
import { useAccess } from 'contexts/AccessContext'

export const DropdownReport = ({ disabled, ...props }: DropdownItemProps) => {
  const { permissions } = useAccess()
  const canDownload = permissions.canDownload
  return (
    <div className="d-flex align-items-center">
      <Dropdown.Item
        className="pr-2"
        disabled={disabled || !canDownload}
        {...props}
      />
      {!canDownload && (
        <div className="mx-2">
          <WithoutPermissionsReports />
        </div>
      )}
    </div>
  )
}
